module.exports = __webpack_public_path__ + "img/AI.e74640f7.svg";